import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const ServiceDetails = lazy(() => import('./service-review/Service-Details'));
const SearchList = lazy(() => import('./service-list/ServiceList'));
const SponsoredServices = lazy(
  () => import('./sponsored-services/SponsoredServices')
);
const NotFound = lazy(() => import('../../components/NotFound'));

const ServicesRoutes = () => {
  const all_services_routes = [
    {
      path: '/search-list',
      name: 'search-list',
      element: <SearchList />,
      route: Route,
    },
    {
      path: '/sponsored-services',
      name: 'sponsoredServices',
      element: <SponsoredServices />,
      route: Route,
    },
    {
      path: '/service-details/:id/:slug',
      name: 'serviceDetails',
      element: <ServiceDetails />,
      route: Route,
    },
    {
      path: '*',
      name: 'NotFound',
      element: <NotFound />,
      route: Route,
    },
  ];
  return (
    <>
      <Routes>
        <Route>
          {all_services_routes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
      </Routes>
    </>
  );
};

export default ServicesRoutes;
